import { render, staticRenderFns } from "./recent-activity.component.vue?vue&type=template&id=3456f620&"
import script from "./recent-activity.component.vue?vue&type=script&lang=ts&"
export * from "./recent-activity.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports